<!-- eslint-disable max-len -->
<template>
    <div
        :style="cssProperties"
        :class="[
            'horizontal-anchor-tab',
            {
                'client-skin-adapt': isSkinAuto,
                dark: isSkinDark
            }
        ]"
        ref="horizontalTabRef"
    >
        <div ref="tabFakeHeader" class="horizontal-anchor-tab-header-fake"></div>
        <div
            class="horizontal-anchor-tab-header-real"
            ref="tabHeaderRealRef"
            :class="{
                'horizontal-anchor-tab-header-scroll': shouldScroll
            }"
        >
            <a
                v-for="(item, idx) of list"
                href="javascript:void(0)"
                :key="'part' + idx"
                class="horizontal-anchor-tab-part"
                @click="() => clickMe(item)"
                :class="{ active: idx === current, circle: !isLineMode }"
            >
                <span v-html="item.title"></span>
            </a>
            <div class="horizontal-anchor-tab-header-active-bar" v-if="isLineMode"></div>
            <div class="horizontal-anchor-tab-header-long-bar" v-if="isLineMode"></div>
        </div>
    </div>
</template>
<script >
import { ref, computed, watch, nextTick } from 'vue-demi';
import { scrollToElement } from '../util';
import { POSITION } from '../constant';
import { useCssProperties } from '../composables/useCssProperties';
import { useHeaderBar } from '../composables/useHeaderBar';
import { useHeaderHorizScroll } from '../composables/useHeaderHorizScroll';
import { useHeaderFixed } from '../composables/useHeaderFixed';
import { useViewport } from '../composables/useViewport';
import { useHeaderActive } from '../composables/useHeaderActive';
const __sfc_main = {};
__sfc_main.props = {
  tpl: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useDark
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = require('../util');
  const {
    store: {
      cmp
    }
  } = require('@futuweb/fego-render');
  const props = __props;
  const horizontalTabRef = ref(null);
  const tabHeaderRealRef = ref(null);
  const tabFakeHeader = ref(null);
  const {
    isAuto: isSkinAuto,
    isDark: isSkinDark
  } = useDark?.() || {};
  const {
    cssProperties
  } = useCssProperties(props);
  const {
    shouldScroll,
    scrollNavToHorizCenter
  } = useHeaderHorizScroll({
    horizontalTabRef,
    props
  });
  const {
    isLineMode,
    resetHeaderBar
  } = useHeaderBar({
    horizontalTabRef,
    props
  });
  const {
    current
  } = useHeaderActive({
    horizontalTabRef,
    props
  }, {
    onItemRenderChange: () => {
      scrollNavToHorizCenter();
    }
  });
  const {
    viewportWidth
  } = useViewport({
    horizontalTabRef,
    props
  });
  useHeaderFixed({
    horizontalTabRef,
    props
  });
  const list = computed(() => props.tpl.props.list || []);
  const clickMe = ({
    target
  }) => {
    if (!target) {
      return;
    }
    const vm = cmp.getVmById(target);
    if (!vm) {
      return;
    }

    // 偏移量
    const mid = props.tpl?.props?.activePosition === POSITION.MID;
    const offset = 0 - (mid ? 0 : tabHeaderRealRef.value.offsetHeight || 0);
    try {
      scrollToElement(vm.$el, {
        mid,
        offset
      });
    } catch (err) {
      console.error('=======clickMe-err=======', err);
    }
  };

  // 当前激活标题发生变化
  watch(() => current.value || shouldScroll.value, () => {
    if (isPreRender()) {
      return;
    }
    // 更新下划线位置
    resetHeaderBar();
    // 横向滚动到当前激活标题
    scrollNavToHorizCenter();
  }, {
    immediate: true
  });

  // 视口变化
  watch(() => viewportWidth.value, () => {
    nextTick(() => {
      // 更新下划线
      if (isPreRender()) {
        return;
      }
      resetHeaderBar();
      // 变更 header-real 的 max-width 值，否则 fixed 时会超出 750
      const horizontalTab = horizontalTabRef.value;
      const horizontalTabRealHeader = tabHeaderRealRef.value;
      if (horizontalTab && horizontalTabRealHeader) {
        const maxWidth = horizontalTab.getBoundingClientRect().width + 'px';
        horizontalTabRealHeader.style.maxWidth = maxWidth;
      }
    });
  }, {
    immediate: true
  });
  return {
    horizontalTabRef,
    tabHeaderRealRef,
    tabFakeHeader,
    isSkinAuto,
    isSkinDark,
    cssProperties,
    shouldScroll,
    isLineMode,
    current,
    list,
    clickMe
  };
};
export default __sfc_main;
</script>
<style scoped lang="less">
@import url(../common.less);
.horizontal-anchor-tab-header {
    width: 100%;
}

.horizontal-anchor-tab-header-real {
    background: inherit;
}
</style>
